import Body from "./Components/Body";

export default function App(){
  return(
    <>
    <Body/>
    </>
  )
}